import { TableCell, TableRow } from "@circle-react-uikit/Table";
import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

export interface RowProps {
  avatarUrl: string;
  email?: string;
  id: string;
  name: string;
  onRemove: (id: string) => void;
}

export const Row = ({ id, avatarUrl, name, email, onRemove }: RowProps) => (
  <TableRow key={id} className="group h-12">
    <TableCell variant="no-padding">
      <div className="mr-2 py-2">
        <UserImage name={name} src={avatarUrl} size="8" />
      </div>
    </TableCell>
    <TableCell variant="no-padding" className="w-full">
      <div className="truncate flex flex-col gap-0 py-2">
        <Typography.LabelSm weight="semibold">{name}</Typography.LabelSm>
        <Typography.LabelXs weight="regular">{email}</Typography.LabelXs>
      </div>
    </TableCell>
    <TableCell variant="no-padding" className="w-24">
      <div className="text-dark invisible group-hover:visible">
        <Button type="button" variant="plain" onClick={() => onRemove(id)}>
          {t("remove")}
        </Button>
      </div>
    </TableCell>
  </TableRow>
);
